import React from 'react';
import { Typography, Container, Grid } from '@mui/material';
// import profileImage from '../assests/images/ameya.jpeg'
import profileImage from '../assests/images/ameya.jpg'
// import profileImage from '../assests/images/ameya.png'
import backgroundImage from '../assests/images/ml.jpg'
import styled, { keyframes } from 'styled-components';
import myImage_ from '../assests/images/education/college2.jpg';
import myImage2_ from '../assests/images/education/spce.png';

const spin = keyframes`
 from {
   transform: rotate(0deg);
 }
 to {
   transform: rotate(360deg);
 }
`;

const RotatingImage = styled.img`
position: 'absolute',
width: '100%',
height: '100%',
objectFit: 'cover',
borderRadius: '50%',
boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
border: '4px solid #fff', // White border around the image
 animation: ${spin} 6s linear infinite; // Apply the animation
`;


const About = () => {
 return (
    <div>
<Container id="about" sx={{ paddingTop: '80px', paddingBottom: '80px' }}>

<Grid container spacing={3} alignItems="center" xs='auto'>
<Grid item xs={12} md={6}>
<div style={{ position: 'relative', width: '100%', paddingBottom: '100%' }}>
<RotatingImage
             src={profileImage}
             alt="Ameya Santosh Gidh"
             style={{
               position: 'absolute',
               width: '100%',
               height: '100%',
               objectFit: 'cover',
               borderRadius: '50%',
               boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
               border: '4px solid #fff', // White border around the image
             }}

           />
</div>
</Grid>
<Grid item xs={12} md={6}>
    
<div
           style={{
             background: '#f7f7f7', // Background color for the text area
             padding: '20px',
             borderRadius: '10px',
             marginLeft: '-20px', // Adjust as needed for alignment
           }}
>
<Typography variant="h4" gutterBottom>
             Hello!
</Typography>
<Typography variant="body1">
Welcome to my online hub! As a software developer, I've built this platform to showcase my projects and connect with fellow enthusiasts. Feel free to explore my work. I strive to inspire and foster connections as we navigate the world of technology together.</Typography>
</div>

</Grid>
</Grid>
</Container>
</div>
 );
};
export default About;